import React, { useState } from "react";
import ConfirmationModal from "./ConfirmationModal";
import { connect } from "react-redux";
import _ from "lodash";

const TopBar = (props) => {
  const [showConfirmationModal, setConfirmationModalVisibility] =
    useState(false);
  const end_slides_button = _.get(
    props,
    "paramsReducer.gameObj.presenting.end_slides_button"
  );
  return (
    <div className="inner-header">
      <button
        className="btn"
        onClick={() => setConfirmationModalVisibility(true)}
      >
        {end_slides_button}
      </button>
      {showConfirmationModal && (
        <ConfirmationModal
          modalVisible={showConfirmationModal}
          setModalVisible={setConfirmationModalVisibility}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
